<template>
  <div class="law">
    <back-home-btn></back-home-btn>

    <v-container class="pa-3 pt-5">
      <h2 class="text-h4">特定商取引法に基づく表記</h2>
      <v-card class="pa-5 mt-3">
        <v-row>
          <template v-for="(item, index) in items">
            <v-col
              :key="`title${index}`"
              cols="12"
              class="text-h6 font-weight-bold pb-1"
            >
              {{ item.title }}
            </v-col>
            <v-col
              :key="`content${index}`"
              cols="12"
              class="text-body-2 pt-1"
            >
              <div>{{ item.content }}</div>
              <div>{{ item.subcontent }}</div>
            </v-col>
          </template>
        </v-row>
      </v-card>
    </v-container>

  </div>
</template>

<script>
import BackHomeBtn from '../components/parts/BackHomeBtn.vue'

export default {
  components: {
    BackHomeBtn,
  },
  data: () => ({
    items: [
      { title: '販売業者', content: '株式会社 今井農園', subcontent: '' },
      { title: '代表責任者', content: '代表取締役 今井 将彦', subcontent: '' },
      { title: '所在地', content: '山梨県北杜市小淵沢町上笹尾 2565', subcontent: '' },
      { title: '電話番号', content: '0551-36-3707', subcontent: '090-8685-5865（担当:今井昭太）' },
      { title: '電話受付時間', content: '9:00 ～18:00', subcontent: '' },
      { title: '公開メールアドレス', content: 'imai.noen1955@gmail.com', subcontent: ''  },
      { title: 'ホームページURL', content: 'http://imainoen.com/', subcontent: '' },
      { title: '販売価格', content: '商品紹介ページをご参照ください', subcontent: '' },
      { title: '商品代金以外の必要料金', content: '消費税／送料', subcontent: '' },
      { title: '引き渡し時期', content: 'ご注文から1週間以内を目安にお届け致します', subcontent: '農繁期により配送が若干遅れる場合がございます。ご了承ください。' },
      { title: 'お支払い方法', content: 'クレジットカード／銀行振込', subcontent: '' },
      { title: '返品・交換・キャンセル等', content: '商品発送後の返品・返却等はお受け致しかねます。', subcontent: '商品が不良の場合のみ良品と交換致します。' },
      { title: '返品期限', content: '商品出荷より7日以内にご連絡下さい。', subcontent: '' },
      { title: '返品送料', content: '不良品の場合は弊社が負担いたします。', subcontent: 'それ以外はお客様のご負担となります。' },
    ],
  }),
}
</script>